import React from 'react'
import cn from "classnames";
import { secondsToDhms } from "../../../core/helpers";
import styles from './Balances.module.sass'


export function BalanceWithTimer({ img, title, amount, amountCur, seconds }) {
    const [timer, setTimer] = React.useState(0);
    React.useEffect(()=>{
        if(seconds&&timer===0) {
            setTimer(seconds)
        }
    },[seconds])
    React.useEffect(() => {
        if (timer > 0) {
            setTimeout(() => setTimer(timer - 1), 1000);
        } else {
            // TODO what do?
        }
    })

    return (
        <div className={cn(styles.box, {
            [styles.timer]: true,
        })}>
            <div className={cn(styles.cap, {
                [styles.timer]: true,
            })}>
                {img && (<img src={img} alt="cnr logo" />)}
            </div>
            <div className={cn(styles.title, {
                [styles.timer]: true,
            })}>{title}</div>
            <div className={styles.amount}>
                <span className={styles.amount_amount}>{amount + ' '}</span>
                <span className={cn(styles.amount_cur, styles.timer)}>{amountCur}</span>
            </div>
            <div className={styles.lastProp}>
                {secondsToDhms(timer)}
            </div>
        </div>
    )
}
